import './AdminRisk.scss'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { Button, Col, notification, Spin, Row, Radio, Icon, Modal, Collapse, Switch, Select, Tooltip, Input, Upload, Progress } from 'antd'
import { getParamsPromise } from './promises'
import { ParamsService } from './services'
import { InfoIcon } from '../../layouts/Private/components'
import {EditRowRiskComponent, RiskCategoryRowComponent, AddCategoryRowComponent} from './components'
import CategoriaDelito from './components/CategoriaDelito/CategoriaDelito'
// import causasPenalesData from './assets/getCausasPenalesDetail.json'

class AdminParams extends Component {
  columnsParams = []
  widthTable = 0

  state = {
    isLoading: true,
    isSaving: false,
    basesRiesgos: {},
    editCode: null,
    modalTitle: null,
    riskBases: [],
    pjudModalVisible: false,
    expandedRows: {},
    
    activeCategories: {} // Mapeo de riskKey -> array de categorías activas
  }

  availableCategories = [
      'COLABORADOR',
      'DIRECTOR',
      'PROVEEDOR',
      'CLIENTE',
      'Entity',
      'Person'
  ];

  async componentDidMount() {
      await this.getParameters()
  }

  // regex para diferentes tipos de cadenas (combinación (riskKey-categoryGeneral-tipoPersona), simple (riskKey-categoryGeneral), tipo de persona (riskKey-tipoPersona))
  categoryPatterns = {
    combination: /^(.+)-(COLABORADOR|DIRECTOR|PROVEEDOR|CLIENTE)-(Entity|Person)$/,
    simple: /^(.+)-(COLABORADOR|DIRECTOR|PROVEEDOR|CLIENTE)$/,
    personType: /^(.+)-(Entity|Person)$/
  }

  // Ordenar categorías alfabéticamente
  sortCategoriesAlphabetically(categories) {
    return [...categories].sort((a, b) => a.localeCompare(b, 'es'))
  }

  // Inicializar categorías activas desde el backend
  initializeActiveCategories(basesRiesgos) {
    if (!basesRiesgos) return {}

    const activeCategories = {}
    
    Object.entries(basesRiesgos).forEach(([key, value]) => {
      if (!value) return
      
      const categoryInfo = this.extractCategoryFromKey(key)
      if (!categoryInfo) return
      
      const { riskKey, category } = categoryInfo
      if (!activeCategories[riskKey]) {
        activeCategories[riskKey] = []
      }
      activeCategories[riskKey].push(category)
    })

    // Ordenar todas las categorías alfabéticamente
    Object.keys(activeCategories).forEach(riskKey => {
      activeCategories[riskKey] = this.sortCategoriesAlphabetically(activeCategories[riskKey])
    })

    return activeCategories
  }

  // Extraer información de categoría de una clave del backend
  extractCategoryFromKey(key) {
    // 1. Buscar combinaciones como PEPHTO-COLABORADOR-Entity
    const combinationMatch = key.match(this.categoryPatterns.combination)
    if (combinationMatch) {
      const [, riskKey, categoryGeneral, tipoPersona] = combinationMatch
      return {
        riskKey,
        category: `${categoryGeneral}-${tipoPersona}`
      }
    }

    // 2. Buscar categorías simples como PEPVTO-COLABORADOR
    const simpleMatch = key.match(this.categoryPatterns.simple)
    if (simpleMatch) {
      const [, riskKey, categoryGeneral] = simpleMatch
      return {
        riskKey,
        category: categoryGeneral
      }
    }

    // 3. Buscar tipos de persona como PEPHTO-Entity
    const personTypeMatch = key.match(this.categoryPatterns.personType)
    if (personTypeMatch) {
      const [, riskKey, personType] = personTypeMatch
      return {
        riskKey,
        category: personType
      }
    }

    return null
  }

  async getParameters() {
    const parameters = await getParamsPromise()
    const activeCategories = this.initializeActiveCategories(parameters.basesRiesgos)
    
    await this.setState({
      isLoading: false,
      basesRiesgos: parameters.basesRiesgos,
      activeCategories
    })
  }



  validaModulo(basesRiesgos, key) {
    if(!basesRiesgos[key]) {
      let elems = document.getElementsByClassName('risk-'+key)
      for(let i=0;i<elems.length;i++) {
        elems[i].classList.add('fields-required')
      }
      return false
    }
    return true
  }

  async saveParamsHandler() {
    const { basesRiesgos, riskBases } = this.state
    const { t } = this.props

    let elems = document.getElementsByClassName('riesgo-cell')
    for(let i=0;i<elems.length;i++) {
      elems[i].classList.remove('fields-required')
    }

    let fieldsRequired = false
    riskBases.map(risk => {
      fieldsRequired = !this.validaModulo(basesRiesgos, risk) || fieldsRequired
    })

    if(fieldsRequired) {
      notification.warning({
        message: t('messages.aml.information'),
        description:  t('messages.aml.missingRiskLevels')
      })
    } else {
      // Mostrar confirmación antes de guardar
      Modal.confirm({
        title: t('messages.aml.confirmation'),
        content: t('messages.aml.confirmSaveParams') || '¿Estás seguro de que deseas guardar los cambios en los parámetros de riesgo?',
        okText: t('messages.aml.yes') || 'Sí',
        cancelText: t('messages.aml.no') || 'No',
        onOk: async () => {
          await this.setState({ isSaving: true })
          const bodyParams = {
            riesgo: basesRiesgos
          }

          const resultSave = await ParamsService.save(bodyParams)

          await this.setState({ isSaving: false })

          if(resultSave.data) {
            notification.success({
              message: t('messages.aml.successfulOperation'),
              description: t('messages.aml.paramsSaved')
            })
          } else {
            notification.error({
              message: t('messages.aml.notifications.anErrorOcurred'),
              description:  t('messages.aml.errorSavingParams')
            })
          }
        }
      })
    }
  }

  handlerChangeRiesgo(key, value) {
    const { basesRiesgos } = this.state
    basesRiesgos[key] = value
    this.setState({ basesRiesgos })
  }

  handleCancel(){
    this.setState({ editCode: null })
  }

  handleOnClickModal = (key, title) => {
    this.setState({editCode: key})
    this.setState({modalTitle: title})
  }

  handlePjudPClick = () => {
    this.setState({ pjudModalVisible: true })
  }

  handlePjudModalCancel = () => {
    this.setState({ pjudModalVisible: false })
  }

  handleToggleRow = (riskKey) => {
    const { expandedRows } = this.state
    expandedRows[riskKey] = !expandedRows[riskKey]
    this.setState({ expandedRows })
  }

  handleCategoryRiskChange = (riskKey, category, value) => {
    const { basesRiesgos } = this.state
    const categoryRiskKey = `${riskKey}-${category}`
    basesRiesgos[categoryRiskKey] = value
    this.setState({ basesRiesgos })
  }

  handleAddCategory = (riskKey, category) => {
    const { basesRiesgos, activeCategories } = this.state
    
    // Agregar categoría si no existe
    if (!activeCategories[riskKey]) {
      activeCategories[riskKey] = []
    }
    
    if (!activeCategories[riskKey].includes(category)) {
      activeCategories[riskKey] = this.sortCategoriesAlphabetically([
        ...activeCategories[riskKey], 
        category
      ])
      
      // Inicializar valor de riesgo
      basesRiesgos[`${riskKey}-${category}`] = basesRiesgos[riskKey]
    }
    
    this.setState({ basesRiesgos, activeCategories: { ...activeCategories } })
  }

  handleDeleteCategory = (riskKey, category) => {
    const { basesRiesgos, activeCategories } = this.state
    
    // Remover la categoría de las activas
    if (activeCategories[riskKey]) {
      activeCategories[riskKey] = activeCategories[riskKey].filter(cat => cat !== category)
    }
    
    // Eliminar el valor de riesgo de la categoría
    const categoryRiskKey = `${riskKey}-${category}`
    delete basesRiesgos[categoryRiskKey]
    
    this.setState({ 
      basesRiesgos,
      activeCategories: { ...activeCategories }
    })
  }

  getAvailableCategoriesForRisk = (riskKey) => {
    // Siempre devolver todas las categorías disponibles
    // La validación de duplicados se hace en AddCategoryRow
    return this.availableCategories
  }

  isRowExpanded = (riskKey) => {
    return this.state.expandedRows[riskKey] || false
  }

  hasCategoryRisks = (riskKey) => {
    const { activeCategories } = this.state
    return activeCategories[riskKey] && activeCategories[riskKey].length > 0
  }

  getRowRisk(title, key, tooltipText, clazz = '') {
    const { t, currentUser } = this.props
    const { basesRiesgos, riskBases } = this.state
    riskBases.push(key)

    const isExpanded = this.isRowExpanded(key)
    const hasCategories = this.hasCategoryRisks(key)
    const hasRequiredModules = currentUser.cliente.modules.includes('REGISTRO') && currentUser.cliente.modules.includes('MONITOR-AML')

    return (
      <>
        <Row style={{display:"flex"}} className="expandable-row">
          <Col xs={6} className={ 'cell-title ' + clazz }>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                { tooltipText && <InfoIcon text={ tooltipText } />} &nbsp;{ t(title) }
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {key === 'PJUD-P' && currentUser.cliente.modules.includes('PJUD-P-CAT') && (
                  <Icon type="edit" onClick={() => this.handlePjudPClick()} style={{ cursor: 'pointer' }} />
                )}
                {key.substring(0, 4) === "ONB-" && (key !== 'ONB-OCTO' && key !== 'ONB-REPR' && key !== 'ONB-CI' && key !== 'ONB-PEP' && key !== 'ONB-FP') && (
                  <Icon type="edit" onClick={() => this.handleOnClickModal(key, t(title))} style={{ cursor: 'pointer' }} />
                )}
                {/* Ícono de expansión a la derecha - solo visible si tiene los módulos requeridos */}
                {hasRequiredModules && (
                  <Tooltip 
                    title={hasCategories ? t('messages.aml.rowHasCategories') : t('messages.aml.rowNoCategories')}
                    placement="top"
                  >
                    <Icon 
                      type={isExpanded ? "minus" : "plus"} 
                      className={`expand-icon ${isExpanded ? 'expanded' : ''}`}
                      onClick={() => this.handleToggleRow(key)}
                      style={{ 
                        color: hasCategories ? '#ff4d4f' : '#1890ff',
                        fontSize: '14px',
                        cursor: 'pointer'
                      }}
                    />
                  </Tooltip>
                )}
              </div>
            </div>
          </Col>
          <Col xs={18} className={ 'riesgo-cell risk-' + key }>
            <Radio.Group value={ basesRiesgos[key] } onChange={ (e) => this.handlerChangeRiesgo(key, e.target.value) }>
              <Radio value='GREEN' />
              <Radio value='YELLOW' />
              <Radio value='ORANGE' />
              <Radio value='RED' />
              <Radio value='BLACK' />
            </Radio.Group>
          </Col>
        </Row>
        
        {/* Filas de categorías expandibles - solo visibles si tiene los módulos requeridos */}
        {isExpanded && hasRequiredModules && (
          <>
            {/* Renderizar categorías activas dinámicamente */}
            {this.state.activeCategories[key] && this.state.activeCategories[key].map(category => (
              <RiskCategoryRowComponent
                riskKey={key}
                category={category}
                label={t('messages.aml.category.' + category)}
                value={basesRiesgos[`${key}-${category}`]}
                onChange={this.handleCategoryRiskChange}
                onDelete={this.handleDeleteCategory}
                isVisible={true}
                basesRiesgos={basesRiesgos}
              />
            ))}
            
            {/* Fila para agregar nuevas categorías */}
            <AddCategoryRowComponent
              riskKey={key}
              basesRiesgos={basesRiesgos}
              availableCategories={this.getAvailableCategoriesForRisk(key)}
              onAddCategory={this.handleAddCategory}
              isVisible={true}
              activeCategories={this.state.activeCategories[key] || []}
            />
          </>
        )}
      </>
    )
  }

  getRowTitleRisk(title) {
    const { t } = this.props
    return <>
      <h3 className="title-section">{ title }</h3>
        <Row>
          <Col xs={6} className="riesgo-cell-column">&nbsp;</Col>
          <Col span={18} className="riesgo-cell-title">
            <Radio.Group style={{ width: '100%' }}>
              {[
                { value: 'GREEN', backgroundColor: '#598756', color: 'white', label: t('messages.aml.risk.N') },
                { value: 'YELLOW', backgroundColor: '#fcdc6b', color: 'black', label: t('messages.aml.low') },
                { value: 'ORANGE', backgroundColor: '#FE9F0C', color: 'white', label: t('messages.aml.medium') },
                { value: 'RED', backgroundColor: '#d9534f', color: 'white', label: t('messages.aml.high') },
                { value: 'BLACK', backgroundColor: '#000000', color: 'white', label: t('messages.aml.critical') }
              ].map((risk, index) => (
                <Radio 
                  key={risk.value}
                  value={risk.value} 
                  style={{ 
                    backgroundColor: risk.backgroundColor,
                    color: risk.color,
                    padding: '8px 16px',
                    borderRadius: '0px',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    cursor: 'default',
                    userSelect: 'none',
                    border: 'none',
                    marginRight: index < 4 ? '0px' : '0px'
                  }}
                >
                  { risk.label }
                </Radio>
              ))}
            </Radio.Group>
          </Col>
        </Row>
    </>
  }

  render() {
    const { t, currentUser } = this.props
    const { isLoading, isSaving, editCode, modalTitle } = this.state

    return (
      <div className="admin-risk">
        <div className="tools-area">
          <Button type="primary" icon={ isSaving ? 'loading': 'save' } onClick={ this.saveParamsHandler.bind(this) }>{ t('messages.aml.save') }</Button>
        </div>
        
        {/* Información sobre riesgos por categoría */}
        {currentUser.cliente.modules.includes('REGISTRO') && currentUser.cliente.modules.includes('MONITOR-AML') && (
          <div style={{ 
            padding: 10, 
            backgroundColor: '#e6f7ff', 
            border: '1px solid #91d5ff', 
            borderRadius: 6 
          }}>
            <Row align="middle">
              <Col span={1}>
                <Icon type="info-circle" style={{ color: '#1890ff', fontSize: '18px' }} />
              </Col>
              <Col span={23}>
                <h4 style={{ margin: '0 0 4px 0', color: '#1890ff' }}>{t('messages.aml.risksByCategory')}</h4>
                <p style={{ margin: 0, color: '#666' }}>
                  {t('messages.aml.riskConfigDescription')}
                </p>
              </Col>
            </Row>
          </div>
        )}
        <div className="table-wrapper">
          { isLoading ?
            <Spin spinning={ true } size="large" />
            :
            <>
                { currentUser.cliente.modules.includes('PEPSAN') &&
                  <>
                    { this.getRowTitleRisk(t('messages.aml.mandatoryLists')) }
                    { currentUser.cliente.modules.includes('PEP') &&
                      <>
                        <Row>
                          <Col xs={24} className="cell-title cell-title-section">{ t('messages.aml.activePEPS') }</Col>
                        </Row>
                        { this.getRowRisk('messages.aml.holderObl', 'PEPVTO', t('messages.aml.tooltipAdminRisk1')) }
                        { this.getRowRisk('messages.aml.holderNoObl', 'PEPVTN', t('messages.aml.tooltipAdminRisk2')) }
                        { this.getRowRisk('messages.aml.relatedObl', 'PEPVRO', t('messages.aml.tooltipAdminRisk3')) }
                        { this.getRowRisk('messages.aml.relatedNoObl', 'PEPVRN', t('messages.aml.tooltipAdminRisk4')) }
                        { currentUser.cliente.pais === 'CHI' &&
                          <>
                            <Row>
                              <Col xs={24} className="cell-section-br"></Col>
                            </Row>
                            { this.getRowRisk('messages.aml.civilServant', 'FP', t('messages.aml.tooltipAdminRisk5'), 'cell-title-section') }
                          </>
                        }
                        <Row>
                          <Col xs={24} className="cell-section-br"></Col>
                        </Row>
                      </>
                    }
                    { currentUser.cliente.modules.includes('PFA') &&
                      <>
                        <Row>
                          <Col xs={24} className="cell-title cell-title-section">WatchList</Col>
                        </Row>
                        { this.getRowRisk('PEP', 'PEPI', t('messages.aml.tooltipAdminRisk6')) }
                        { this.getRowRisk('messages.aml.related', 'RCAI', t('messages.aml.tooltipAdminRisk7')) }
                        { this.getRowRisk('messages.aml.specialInterest', 'WLSI', t('messages.aml.tooltipAdminRisk18')) }
                        { this.getRowRisk('messages.aml.sanctioned', 'WLSAN', t('messages.aml.tooltipAdminRisk8')) }
                        { this.getRowRisk('messages.aml.otherLists', 'WLOOL', t('messages.aml.tooltipAdminRisk9')) }
                        { currentUser.cliente.pais === 'CHI' && this.getRowRisk('messages.aml.uafLists', 'UAF', t('messages.aml.tooltipAdminRisk10')) }
                        <Row>
                          <Col xs={24} className="cell-section-br"></Col>
                        </Row>
                      </>
                    }
                    { currentUser.cliente.modules.includes('NEG') &&
                      this.getRowRisk('messages.aml.ownLists', 'NEG', t('messages.aml.tooltipAdminRisk11'), 'cell-title-section')
                    }
                  </>
                }

                { currentUser.cliente.modules.includes('KYCAME') &&
                  <>
                    { this.getRowTitleRisk(t('messages.aml.knowYourCustomer')) }
                    { currentUser.cliente.modules.includes('PEPH') &&
                      <>
                        <Row>
                          <Col xs={24} className="cell-title cell-title-section">{ t('messages.aml.historicalPEPS') }</Col>
                        </Row>
                        { this.getRowRisk('messages.aml.holderObl', 'PEPHTO', t('messages.aml.tooltipAdminRisk12')) }
                        { this.getRowRisk('messages.aml.holderNoObl', 'PEPHTN', t('messages.aml.tooltipAdminRisk13')) }
                        { this.getRowRisk('messages.aml.relatedObl', 'PEPHRO', t('messages.aml.tooltipAdminRisk14')) }
                        { this.getRowRisk('messages.aml.relatedNoObl', 'PEPHRN', t('messages.aml.tooltipAdminRisk15')) }
                        <Row>
                          <Col xs={24} className="cell-section-br"></Col>
                        </Row>
                      </>
                    }
                    { currentUser.cliente.modules.includes('PEPC') &&
                      <>
                        <Row>
                          <Col xs={24} className="cell-title cell-title-section">{ t('messages.aml.candidates') }</Col>
                        </Row>
                        { this.getRowRisk('messages.aml.holder', 'PEPC', t('messages.aml.tooltipAdminRisk16')) }
                        { this.getRowRisk('messages.aml.related', 'RCAC', t('messages.aml.tooltipAdminRisk17')) }
                        <Row>
                          <Col xs={24} className="cell-section-br"></Col>
                        </Row>
                      </>
                    }
                    { currentUser.cliente.modules.includes('PFA') &&
                      <>
                        <Row>
                          <Col xs={24} className="cell-title cell-title-section">Adverse Media</Col>
                        </Row>
                        { this.getRowRisk('messages.aml.specialInterest', 'AMESI', t('messages.aml.tooltipAdminRisk18')) }
                        { this.getRowRisk('messages.aml.sanctioned', 'AMESAN', t('messages.aml.tooltipAdminRisk8')) }
                        { this.getRowRisk('messages.aml.otherLists', 'AMEOOL', t('messages.aml.tooltipAdminRisk9')) }
                        <Row>
                          <Col xs={24} className="cell-section-br"></Col>
                        </Row>
                      </>
                    }
                    { currentUser.cliente.modules.includes('PERSON') &&
                      this.getRowRisk('messages.aml.personsOfInterest', 'BPI', t('messages.aml.tooltipAdminRisk19'), 'cell-title-section')
                    }
                    { currentUser.cliente.modules.includes('VIP') &&
                      this.getRowRisk('VIP', 'VIP', t('messages.aml.tooltipAdminRisk20'), 'cell-title-section')
                    }
                    { (currentUser.cliente.modules.includes('PJUD-CIVIL') || currentUser.cliente.modules.includes('PJUD-PENAL')
                      || currentUser.cliente.modules.includes('PJUD-LAB') || currentUser.cliente.modules.includes('PJUD-COB')
                      || currentUser.cliente.modules.includes('PJUD-APE') || currentUser.cliente.modules.includes('PJUD-SUP')) &&
                      <>
                        <Row>
                          <Col xs={24} className="cell-title cell-title-section">{ t('messages.aml.powerOfAttorney') }</Col>
                        </Row>
                        { currentUser.cliente.modules.includes('PJUD-CIVIL') &&
                          this.getRowRisk('messages.aml.civilCauses', 'PJUD-C', t('messages.aml.tooltipAdminRisk21'))
                        }
                        { currentUser.cliente.modules.includes('PJUD-PENAL') &&
                          this.getRowRisk('messages.aml.criminalCauses', 'PJUD-P', t('messages.aml.tooltipAdminRisk21'))
                        }
                        { currentUser.cliente.modules.includes('PJUD-LAB') &&
                          this.getRowRisk('messages.aml.laborCauses', 'PJUD-LAB', t('messages.aml.tooltipAdminRisk21'))
                        }
                        { currentUser.cliente.modules.includes('PJUD-COB') &&
                          this.getRowRisk('messages.aml.collectionCauses', 'PJUD-COB', t('messages.aml.tooltipAdminRisk21'))
                        }
                        { currentUser.cliente.modules.includes('PJUD-APE') &&
                          this.getRowRisk('messages.aml.courtAppeals', 'PJUD-APE', t('messages.aml.tooltipAdminRisk21'))
                        }
                        { currentUser.cliente.modules.includes('PJUD-SUP') &&
                          this.getRowRisk('messages.aml.supremeCourt', 'PJUD-SUP', t('messages.aml.tooltipAdminRisk21'))
                        }
                        <Row>
                          <Col xs={24} className="cell-section-br"></Col>
                        </Row>
                      </>
                    }
                    { currentUser.cliente.modules.includes('MAM') &&
                      <>
                        <Row>
                          <Col xs={24} className="cell-title cell-title-section">Medio ambiente</Col>
                        </Row>
                        { this.getRowRisk('messages.aml.mam.title', 'MAM', t('messages.aml.tooltipAdminRiskMam')) }
                        <Row>
                          <Col xs={24} className="cell-section-br"></Col>
                        </Row>
                      </>
                    }
                  </>
                }
                { currentUser.cliente.modules.includes('UBOCOM') &&
                  <>
                    { this.getRowTitleRisk('UBO & Companies') }
                    { currentUser.cliente.modules.includes('PFA') &&
                      <>
                        <Row>
                          <Col xs={24} className="cell-title cell-title-section">State Owned Companies</Col>
                        </Row>
                        { this.getRowRisk('Board Member', 'SOCBRD', t('messages.aml.tooltipAdminRisk22')) }
                        { this.getRowRisk('State Owned Companies', 'SOCSOC', t('messages.aml.tooltipAdminRisk23')) }
                      </>
                    }
                  </>
                }
                { currentUser.cliente.modules.includes('ONBOARDING') &&
                  <>
                    { this.getRowTitleRisk('Reglas Demográficas') }
                        <Row>
                          <Col xs={24} className="cell-title cell-title-section">Onboarding</Col>
                        </Row>
                        { this.getRowRisk('messages.aml.titles.ONB-NAT', 'ONB-NAT') }
                        { this.getRowRisk('messages.aml.titles.ONB-EXP', 'ONB-EXP') }
                        { this.getRowRisk('messages.aml.titles.ONB-CONS', 'ONB-CONS') }
                        { this.getRowRisk('messages.aml.titles.ONB-MAT', 'ONB-MAT') }
                        { currentUser.cliente.pais === 'PER' && 
                          this.getRowRisk('messages.aml.titles.ONB-PROVI', 'ONB-PROVI') 
                        }
                        { this.getRowRisk('messages.aml.titles.ONB-OCTO', 'ONB-OCTO') }
                        { this.getRowRisk('messages.aml.titles.ONB-DONA', 'ONB-DONA') }
                        { this.getRowRisk('messages.aml.titles.ONB-REPR', 'ONB-REPR') }
                        { this.getRowRisk('messages.aml.titles.ONB-PEP', 'ONB-PEP') }
                        { currentUser.cliente.pais === 'CHI' && 
                          this.getRowRisk('messages.aml.titles.ONB-FP', 'ONB-FP') 
                        }
                        { this.getRowRisk('messages.aml.titles.ONB-CI', 'ONB-CI') }
                        { this.getRowRisk('messages.aml.titles.ONB-ACTE', 'ONB-ACTE') }
                        { this.getRowRisk('messages.aml.titles.ONB-TSA', 'ONB-TSA') }
                        { this.getRowRisk('messages.aml.titles.ONB-TSM', 'ONB-TSM') }
                        { this.getRowRisk('messages.aml.titles.ONB-TSB', 'ONB-TSB') }

                  </>
                }
                {editCode &&
                  <EditRowRiskComponent editCode={editCode} modalTitle={modalTitle} handleCancel={ this.handleCancel.bind(this) }/>
                }
                <CategoriaDelito 
                  visible={this.state.pjudModalVisible}
                  onCancel={this.handlePjudModalCancel}
                  t={this.props.t}
                />
            </>
          }
        </div>
      </div>
    )
  }
}

export default withTranslation()(AdminParams)